import { FC } from "react";
import { Dialog, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { BrokerForm } from "../brokerForm";
import { useCreateBroker } from "../dataHooks/brokerQueries";

type Props = {};

export const NewBroker: FC<Props> = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const createBroker = useCreateBroker({
    onSuccess: () => navigate("/brokers")
  });

  return (
    <Dialog
      maxWidth="md"
      fullWidth
      onClose={() => navigate("/brokers")}
      open={location.pathname === "/brokers/new"}
    >
      <DialogTitle>
        <Typography variant="h5">Onboard New Broker</Typography>
      </DialogTitle>
      <DialogContent>
        <BrokerForm
          onSubmit={(payload) => createBroker.mutate(payload)}
          submitting={createBroker.isPending}
          submitLabel="Create"
          onCancel={() => navigate("/brokers")}
        />
      </DialogContent>
    </Dialog>
  );
};
